/*
 * Module for conversation transcript
 */

define([
  "marionette",
  "modules/learner/learnerTranscriptModal/conversationTranscript/conversationTranscriptView",
], function (Marionette, ConversationTranscriptView) {
  var ConversationTranscriptController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "conversationTranscript";
      this.region = options.region;
    },
    show: function (conversationTranscript, turn) {
      this.view = new ConversationTranscriptView.conversationTranscriptView({
        turn: turn,
        collection: conversationTranscript,
      });
      this.showRegion(this.view, { loading: true });
    },
  });

  return ConversationTranscriptController;
});
